<template>
  <div v-if="step === 1">
    <div style="margin: -20px 0 12px">该商品已发起过售后申请，是否继续发起</div>
    <el-table border :data="dataList" max-height="400px" style="width: 100%">
      <el-table-column
        prop="userAfterSalesCode"
        align="center"
        label="售后单号"
      >
      </el-table-column>
      <el-table-column prop="name" align="center" label="状态">
        <template slot-scope="scope">
          {{
            $getDictLabel(
              'USER_AFTER_SALES_STATUS',
              scope.row.userAfterSalesStatus
            )
          }}
        </template>
      </el-table-column>
      <el-table-column prop="userName" align="center" label="申请人">
      </el-table-column>
      <el-table-column
        prop="userAfterSalesType"
        align="center"
        label="申请类型"
      >
        <template slot-scope="scope">
          {{
            $getDictLabel('USER_AFTER_SALES_TYPE', scope.row.userAfterSalesType)
          }}
        </template>
      </el-table-column>
      <el-table-column
        prop="reason"
        align="center"
        label="申请原因"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column prop="address" align="center" label="详情">
        <template slot-scope="scope">
          <el-button type="text" @click="() => showDetail(scope.row)"
            >详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: center; padding-top: 18px">
      <el-button size="small" :loading="loading" @click="cancel"
        >取消</el-button
      >
      <el-button
        type="primary"
        :loading="loading"
        size="small"
        @click="step = 2"
        >继续发起</el-button
      >
    </div>
    <el-dialog
      title="售后详情"
      :visible.sync="dialogVisible"
      append-to-body
      width="800px"
    >
      <div v-if="dialogVisible">
        <el-descriptions
          title=""
          style="margin-top: -20px"
          :column="1"
          :colon="false"
        >
          <el-descriptions-item label="商品编码：">{{
            row.oldGoodsCode || row.goodsCode || '-'
          }}</el-descriptions-item>
          <el-descriptions-item label="商品名称：">{{
            row.oldGoodsName || row.goodsName || '-'
          }}</el-descriptions-item>
          <el-descriptions-item label="品牌：">{{
            row.oldBrand || row.brandName || '-'
          }}</el-descriptions-item>
          <el-descriptions-item label="型号：">
            {{ row.goodsModel || '-' }}
          </el-descriptions-item>
        </el-descriptions>
        <template>
          <el-descriptions
            title=""
            :column="1"
            :colon="false"
            :contentStyle="CS"
            :label-style="LS"
          >
            <el-descriptions-item label="申请类型：">
              {{
                $getDictLabel(
                  'USER_AFTER_SALES_TYPE',
                  detail.userAfterSalesType
                )
              }}
            </el-descriptions-item>
            <el-descriptions-item label="申请数量：">
              {{ detail.afterSalesNum }}
            </el-descriptions-item>
            <el-descriptions-item label="申请原因：">
              <div class="reason">{{ detail.reason || '-' }}</div>
            </el-descriptions-item>
          </el-descriptions>
          <div style="text-align: center">
            <el-button size="small" @click="dialogVisible = false"
              >关闭</el-button
            >
          </div>
        </template>
      </div>
    </el-dialog>
  </div>
  <div v-else>
    <el-descriptions
      title=""
      style="margin-top: -20px"
      :column="1"
      :colon="false"
    >
      <el-descriptions-item label="商品编码：">{{
        row.oldGoodsCode || row.goodsCode || '-'
      }}</el-descriptions-item>
      <el-descriptions-item label="商品名称：">{{
        row.oldGoodsName || row.goodsName || '-'
      }}</el-descriptions-item>
      <el-descriptions-item label="品牌：">{{
        row.oldBrand || row.brandName || '-'
      }}</el-descriptions-item>
      <el-descriptions-item label="型号：">
        {{ row.goodsModel || '-' }}
      </el-descriptions-item>
    </el-descriptions>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="95px"
      class="demo-ruleForm"
    >
      <el-form-item label="申请类型：" prop="userAfterSalesType">
        <el-select
          size="small"
          clearable
          filterable
          v-model="ruleForm.userAfterSalesType"
          placeholder="请选择"
        >
          <el-option
            v-for="(item, index) in options"
            :key="index"
            :label="item.value"
            :value="item.code"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="申请数量：" prop="afterSalesNum">
        <el-input-number
          size="small"
          v-model="ruleForm.afterSalesNum"
          :min="1"
          :max="row.goodsNum"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="申请原因：" prop="reason">
        <el-input
          type="textarea"
          placeholder="请输入"
          v-model="ruleForm.reason"
          maxlength="500"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="附件：" prop="fileOssIds">
        <Upload
          :buttonText="'上传附件'"
          :tip="'单个文件大小不能超过100mb,且上传文件个数不超过20个'"
          :limit="20"
          :action="action"
          @onSuccess="getFileList"
        ></Upload>
      </el-form-item>
      <el-form-item label="备注：" prop="remark">
        <el-input
          type="textarea"
          placeholder="请输入"
          v-model="ruleForm.remark"
          maxlength="500"
          show-word-limit
        ></el-input>
      </el-form-item>
      <div style="text-align: center; padding-top: 18px">
        <el-button size="small" :loading="loading" @click="cancel"
          >取消</el-button
        >
        <el-button
          type="primary"
          :loading="loading"
          size="small"
          @click="submit('ruleForm')"
          >确定</el-button
        >
      </div>
    </el-form>
  </div>
</template>

<script>
import Upload from '@/components/upload/file'
export default {
  components: {
    Upload
  },
  props: {
    row: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      action: window.SITE_CONFIG.apiURL + '/front/fileupload/alioss/upload',
      CS: {
        'word-break': 'break-all' // 过长时自动换行
      },

      LS: {
        'word-break': 'keep-all'
      },
      step: 2,
      options: [...(window.SITE_CONFIG.dictList.USER_AFTER_SALES_TYPE || '')],
      ruleForm: {
        userAfterSalesType: '',
        afterSalesNum: undefined,
        reason: '',
        fileOssIds: [],
        remark: ''
      },
      rules: {
        userAfterSalesType: [
          { required: true, message: '请选择申请类型', trigger: 'change' }
        ],
        afterSalesNum: [
          { required: true, message: '请输入申请数量', trigger: 'change' }
        ],
        reason: [
          { required: true, message: ' ', trigger: 'change' }
        ]
      },
      loading: false,
      detail: {},
      dialogVisible: false,
      dataList: []
    }
  },
  created () {
    // 如果是已经评价的
    if (
      this.row.goodsItemList &&
      this.row.goodsItemList.length &&
      this.row.goodsItemList[0].afterSaleApplied
    ) {
      this.step = 1
      this.getList()
    }
  },
  methods: {
    getFileList (fileList) {
      this.ruleForm.fileOssIds = fileList
    },
    // 查看已申请的
    showDetail (row) {
      this.detail = row
      this.dialogVisible = true
    },
    cancel () {
      this.$emit('cancel')
    },
    submit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.doSubmit()
        }
      })
    },
    // 确定提交
    doSubmit () {
      if (this.loading) {
        return
      }
      this.loading = true
      let detail = {}
      if (this.row.goodsItemList.length) {
        detail = this.row.goodsItemList[0]
      }
      const obj = {
        orderId: this.row.orderId,
        goodsItemList: [
          {
            ...detail,
            afterSalesNum: this.ruleForm.afterSalesNum,
            afterSalesAmount: (
              this.ruleForm.afterSalesNum * detail.transactionPrice
            ).toFixed(2)
          }
        ],
        userAfterSalesType: this.ruleForm.userAfterSalesType,
        reason: this.ruleForm.reason,
        fileOssIds: this.ruleForm.fileOssIds,
        remark: this.ruleForm.remark,
        // 来源平台：0--未知; 1--运营平台; 2--商城; ; 4--webshop; 5--销售助手
        platformSource: '2'
      }
      this.$http
        .post('/front/webshop/lclb/userAfterSales/add', obj)
        .then(({ data: res }) => {
          this.loading = false
          if (res.code === 0) {
            this.$message.success('操作成功')
            this.$emit('success')
          }
        })
    },
    // 确定提交
    getList () {
      const obj = {
        orderCode: this.row.orderCode,
        goodsSkuId: this.row.goodsSkuId,
        appCode: 'PLANTMATE_OFFICIAL',
        // 数据权限控制 1商城端 2webShop端 3发起收某订单全部售后数据
        queryDataPermissionsType: '3'
      }
      this.$http
        .post('/front/webshop/lclb/userAfterSales/list', obj)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.dataList = res.data.data || []
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.reason {
  max-height: 400px;
  overflow: auto;
}
.demo-ruleForm ::v-deep .el-upload__tip {
  margin: 0;
  line-height: 16px;
}
</style>
